import React from "react";
import { NavLink } from "react-router-dom";

/**
 * Desktop primary navigation. The active style is owned by the NavLink itself
 * via the textTone passed in (inherited from Header's scroll state).
 */
export default function Nav({ items, textTone }) {
  return (
    <nav
      aria-label="Primary"
      className="hidden lg:flex items-center gap-9"
      data-testid="header-nav"
    >
      {items.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.to === "/"}
          data-testid={`nav-link-${item.slug}`}
          className={({ isActive }) =>
            `eyebrow link-underline transition-colors duration-500 ${textTone} ${
              isActive ? "opacity-100" : "opacity-80 hover:opacity-100"
            }`
          }
        >
          {item.label}
        </NavLink>
      ))}
    </nav>
  );
}
